import axios from 'axios';

import { NotificationManager } from 'react-notifications';

import config from '../../config';
import { history } from '../../store';

// axios.interceptors.request.use(function (config) {
//    const token = localStorage.getItem("userTokenBilsis");
//    config.headers.Authorization =  token;

//    return config; 
// });


axios.interceptors.response.use(response => {
   return response;
}, error => {
  // Eğer response yoksa (network hatası gibi), interceptor'ı bypass et
  if (!error.response) {
    return Promise.reject(error);
  }

  // 400 Bad Request durumunda 404'e yönlendirme (kullanıcıya hata mesajı gösterilmeli)
  if (error.response.status === 400) {
    return Promise.reject(error);
  }

  if (error.response.status === 403) {
   console.log(" ****** ana hata yakalamayaya girdi 403");
   NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor.' )    
  // console.log("token ",localStorage.getItem("userTokenYaysis"))
  
    localStorage.removeItem("userBilsis");
    localStorage.removeItem("userTokenBilsis");
   window.location.href =  config.mainPageUrl + `?status=false&message=Oturmunuzun süresi dolmuştur. Yeniden giriş yapınız.&code=403`;
   history.push("/bys/403");
}
else if (error.response.status === 401) {
   console.log(" ****** ana hata yakalamayaya girdi 401");
   NotificationManager.error('Yetkisiz erişim' )     
   history.push("/bys/401");
   return {status:false , data: null , messages : "Yetkisiz erişim"}
}
else
{
   history.push("/bys/404");
}

  return error;
});



export const postUserOtherAuthCheck = async(user)=>{
   const token = localStorage.getItem("userTokenBilsis");
      const configAxios = {
         headers: { Authorization: "Bearer " + token }
      }

   const url = `${config.userCheckApiUrl}`;
   return await axios.post(url,user,configAxios)
   .then(response => response.data);
}


export const postCreateUserApi = async(user)=>{
   const token = localStorage.getItem("userTokenBilsis");
   const configAxios = {
      headers: { Authorization: "Bearer " + token }
   }

   const url = `${config.apiUrl}/v1/auth/signUp`;
   return await axios.post(url,user,configAxios)
   .then(response => response.data)
}
